import { Commit } from 'vuex';
import { ContactState } from '.';

export interface ContactActionType {
    commit: Commit;
    state: ContactState;
    getters: any;
}

export enum ContactActions {
    GET_INTERLOCUTEURS_LIST = 'GET_INTERLOCUTEURS_LIST',
    SEND_MESSAGE = 'SEND_MESSAGE',
    GET_EXPORT_CONTACTS = 'GET_EXPORT_CONTACTS',
}
